import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Lenis from 'lenis';

gsap.registerPlugin(ScrollTrigger);


import Cursor from './components/Cursor';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Philosophy from './components/Philosophy';
import Protocol from './components/Protocol';
import StatsCounter from './components/StatsCounter';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Trust from './components/Trust';
import FAQ from './components/FAQ';
import Testimonials from './components/Testimonials';
import PricingEstimator from './components/PricingEstimator';

import { Phone } from 'lucide-react';

function App() {
  const appRef = useRef(null);

  useEffect(() => {
    // Initialize Lenis
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    lenis.on('scroll', () => {
      ScrollTrigger.update();
    });

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);

    // Intercept all anchor links for smooth scrolling
    const handleAnchorClick = (e) => {
      const target = e.currentTarget;
      const href = target.getAttribute('href');
      
      // Check if it's an internal link
      if (href && href.startsWith('#')) {
        const targetElement = document.querySelector(href);
        if (targetElement) {
          e.preventDefault();
          lenis.scrollTo(targetElement, {
            offset: -100, // Offset for fixed navbar
            duration: 1.5,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
          });
        }
      }
    };

    // Attach listener to all relevant links
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    anchorLinks.forEach(link => {
      link.addEventListener('click', handleAnchorClick);
    });

    let ctx = gsap.context(() => {
      // Global animations or scroll trigger refreshes can go here.
    }, appRef);

    return () => {
      ctx.revert();
      
      // Cleanup event listeners
      anchorLinks.forEach(link => {
        link.removeEventListener('click', handleAnchorClick);
      });
      
      lenis.destroy();
      gsap.ticker.remove(lenis.raf);
    };
  }, []);

  return (
    <>

      <Cursor />
      <div ref={appRef} className="relative w-full min-h-screen bg-background text-dark selection:bg-accent selection:text-background font-body overflow-x-hidden">
        <div className="noise-overlay"></div>

        <Navbar />

        <main>
          <Hero />
          <StatsCounter />
          <Features />
          <Trust />
          <Philosophy />
          <Protocol />
          <Testimonials />
          <PricingEstimator />
          <FAQ />
          <Contact />
        </main>

        <Footer />

        {/* Sticky Mobile CTA */}
        <div className="fixed sm:hidden bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-background via-background/90 to-transparent z-50 pointer-events-none">
          <a
            href="#kontakt"
            className="pointer-events-auto w-full flex items-center justify-center gap-2 bg-accent text-background font-heading font-bold text-base py-4 rounded-[2rem] uppercase tracking-wide shadow-2xl active:scale-95 transition-transform"
          >
            <Phone size={18} />
            Darmowa Wycena
          </a>
        </div>

      </div>
    </>
  );
}

export default App;
